module.exports = __webpack_public_path__ + "static/texture-dark-8a9a739291a5cba65abbfd723fce715a.png";